import lang from '../../lib/language';
import { LeaderboardRequestedCompetitor } from '../../lib/store/reporting/types';

export const PositionHeaders = [
  '',
  '',
  lang.commonMyPositionYou(),
  lang.commonPL(),
  lang.mobileSortByPercentChange(),
  lang.commonMyPositionAward(),
];

export const LeaderboardHeaders = [
  lang.commonPosition(),
  lang.commonPlayer(),
  lang.commonPL(),
  lang.mobileSortByPercentChange(),
  lang.commonMyPositionAward(),
];

export const DEFAULT_POSITION_DATA: LeaderboardRequestedCompetitor = {
  rank: 0,
  sharingRank: 0,
  tradingPlanId: 0,
  accountReferenceId: '',
  profileName: '',
  firstName: '',
  lastName: '',
  netEquity: 0,
  pnL: 0,
  prize: 0,
  currency: '',
  requestedAccountReferenceId: '',
};
